var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMacIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.988,
    height: 32,
    viewBox: "0 0 26.988 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Apple_logo_black",
    d: "M22.64,31.711c-1.736,1.684-3.651,1.422-5.476.628a6.938,6.938,0,0,0-5.764,0c-2.552,1.1-3.907.781-5.444-.628-8.679-8.935-7.4-22.545,2.466-23.058,2.392.128,4.067,1.323,5.476,1.422C15.992,9.65,18,8.43,20.238,8.59a7.723,7.723,0,0,1,6.053,3.193,7.04,7.04,0,0,0,.861,12.682,18,18,0,0,1-4.515,7.27ZM13.705,8.558A7.291,7.291,0,0,1,20.366,1C20.875,5.579,16.2,9.006,13.705,8.558Z",
    transform: "translate(-0.164 -1)",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacIcon);
export default __webpack_public_path__ + "static/media/mac_icon.d36afbaa.svg";
export { ForwardRef as ReactComponent };